<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-22T23:19:46+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe
@Last modified by:   tom
@Last modified time: 2019-06-08T12:08:29+02:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved
-->

<template>
  <div id="app">
    <navbar/>
    <main>
      <router-view/>
    </main>
    <social-sharer
      title="Qrespi - Connect to Care from APP - default"
      twitterUser="qrepsi"
      description="Puck by Qrespi - Touch to Care"
      quote="It changed my life"
      hashtags="qrespi, care, livingalone"/>
  </div>
</template>

<script>
import Vue from 'vue'

// sub components we need in all/most pages
import Navbar from '@/components/_shared/Navbar'
import NavBottom from '@/components/_shared/NavBottom'

import LocSwitcher from '@/lib/lang/_locale-switcher'
import CurrSwitcher from '@/lib/lang/_currency-switcher'
import TypeWriter from '@/components/_shared/_typewriter'
import ResponseForm from '@/components/_shared/_responseform'

import SocialSharer from '@/lib/share/SocialSharer'
import SocialShareButton from '@/lib/share/SocialShareButton'

// https://rigor789.github.io/vue-scrollto/#/
import VueScrollTo from 'vue-scrollto'

// register components we need on home page
Vue.component('navbar', Navbar)
Vue.component('navbottom', NavBottom)
Vue.component('typewriter', TypeWriter)
Vue.component('responseform', ResponseForm)
Vue.component('social-sharer', SocialSharer)
Vue.component('social-share-button', SocialShareButton)

Vue.component('currency-switcher', CurrSwitcher)
Vue.component('locale-switcher', LocSwitcher)

// register lazy, components we need often but not on home page
Vue.component('c-page', () => import('@/components/_shared/_page'))
Vue.component('slideshow', () => import('@/components/_shared/_slideshow'))
Vue.component('accordion', () => import('@/components/_shared/_accordion'))

// ** Use & intialize module defaults

// smooth scrolling in singple page app - page
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  // offset same as in router/index.js for direct jump from other page
  offset: -55,
  cancelable: true,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

export default {
  name: 'App'
}

// // repeating the color table from the theme.scss for usage in Javascript
// // Use in components, example: this.$COLOR_TABLE['secondary']
// See _page.vue in lib
Vue.prototype.$COLOR_TABLE = {
  primary: '#203559',
  secondary: '#8D733F',
  success: '#9cc06e',
  info: '#4c6da6',
  warning: '#b44848',
  light: '#c3af86',
  dark: '#2d230c',
  danger: '#df2121'
}
// Array with color variant strings, to loop over
Vue.prototype.$COLOR_VARIANTS = Object.keys(Vue.prototype.$COLOR_TABLE)

</script>

<style lang="scss">

  // see /vue.config.js for:
  //   @import "assets/style/theme.scss";
  @import "assets/style/extras.scss";
  @import "~bootstrap/scss/bootstrap.scss";
  @import '~bootstrap-vue/dist/bootstrap-vue.css';

  #update-alert {
    top: 66px;
    position: absolute;
    padding-right: 50px;
  }

  main {
    margin-top: 48px;
  }

</style>
